import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTypesAttraction = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_10846_87583)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M13.2916 14.6563C11.2753 12.9097 10.9014 9.92344 12.4248 7.73366C13.9482 5.54387 16.8782 4.85612 19.2169 6.13937L22.5799 7.98472C25.5099 9.59241 26.4001 13.385 24.4915 16.1285C22.5829 18.8719 18.7173 19.3559 16.1912 17.1678L13.2916 14.6563Z",
				fill: "#E4860C"
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .5,
				filter: "url(#filter0_f_10846_87583)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M15.0018 13.5692C13.81 12.5369 13.589 10.7717 14.4894 9.47736C15.3899 8.183 17.1218 7.77648 18.5042 8.535L20.492 9.62576C22.2239 10.576 22.7501 12.8178 21.6219 14.4394C20.4938 16.061 18.2089 16.3472 16.7157 15.0538L15.0018 13.5692Z",
					fill: "#F4CF6E"
				})
			}),
			/* @__PURE__ */ _jsx("foreignObject", {
				x: -17.3765,
				y: -13.8787,
				width: 70.7529,
				height: 68.4775,
				children: /* @__PURE__ */ _jsx("div", {
					xmlns: "http://www.w3.org/1999/xhtml",
					style: {
						backdropFilter: "blur(12px)",
						clipPath: "url(#bgblur_1_10846_87583_clip_path)",
						height: "100%",
						width: "100%"
					}
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-figma-bg-blur-radius": 24,
				d: "M28.5232 22.0397C27.5892 22.0397 26.8293 21.2867 26.8293 20.3613C26.8293 19.4347 27.5892 18.6817 28.5232 18.6817C28.7496 18.6817 28.9669 18.5926 29.1262 18.4348C29.2866 18.2759 29.3764 18.0606 29.3764 17.8362L29.3753 14.7904C29.3753 12.2158 27.2604 10.1213 24.662 10.1213H11.3379C8.73956 10.1213 6.62467 12.2158 6.62467 14.7904L6.62354 17.9343C6.62354 18.1586 6.71341 18.3739 6.87382 18.5329C7.03309 18.6907 7.25038 18.7797 7.47677 18.7797C8.44263 18.7797 9.17072 19.4595 9.17072 20.3613C9.17072 21.2867 8.41078 22.0397 7.47677 22.0397C7.00578 22.0397 6.62354 22.4185 6.62354 22.8852V25.9288C6.62354 28.5034 8.73728 30.5989 11.3368 30.5989H24.6632C27.2627 30.5989 29.3764 28.5034 29.3764 25.9288V22.8852C29.3764 22.4185 28.9942 22.0397 28.5232 22.0397Z",
				fill: "url(#paint0_linear_10846_87583)"
			}),
			/* @__PURE__ */ _jsx("foreignObject", {
				x: -1.15869,
				y: 1.03784,
				width: 38.3169,
				height: 37.9932,
				children: /* @__PURE__ */ _jsx("div", {
					xmlns: "http://www.w3.org/1999/xhtml",
					style: {
						backdropFilter: "blur(7.5px)",
						clipPath: "url(#bgblur_2_10846_87583_clip_path)",
						height: "100%",
						width: "100%"
					}
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				filter: "url(#filter2_d_10846_87583)",
				"data-figma-bg-blur-radius": 15,
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M21.9028 19.8922L20.5615 21.1982L20.8789 23.0446C20.9335 23.3643 20.8049 23.6794 20.5422 23.8683C20.2816 24.0594 19.9415 24.0833 19.6548 23.9308L17.9995 23.0605L16.3408 23.932C16.218 23.9968 16.0837 24.0309 15.9506 24.0309C15.7766 24.0309 15.6048 23.9763 15.4569 23.8694C15.1952 23.6794 15.0667 23.3643 15.1213 23.0446L15.4375 21.1982L14.0963 19.8922C13.8642 19.6669 13.7834 19.3359 13.8835 19.0276C13.9848 18.7204 14.2464 18.502 14.5661 18.4565L16.4159 18.1869L17.2453 16.5066C17.3897 16.2176 17.6787 16.0378 17.9995 16.0378H18.0018C18.3237 16.039 18.6127 16.2187 18.7549 16.5077L19.5843 18.1869L21.4375 18.4576C21.7537 18.502 22.0154 18.7204 22.1155 19.0276C22.2168 19.3359 22.136 19.6669 21.9028 19.8922Z",
					fill: "white"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M17.9995 16.1482H18.0015C18.2818 16.1492 18.5321 16.3051 18.6558 16.5564H18.6567L19.4858 18.2351L19.5112 18.2869L19.5679 18.2957L21.4214 18.5662H21.4224C21.6968 18.6047 21.9241 18.7942 22.0112 19.0613V19.0623C22.0992 19.3307 22.0291 19.6176 21.8267 19.8132H21.8257L20.4849 21.1199L20.4429 21.1599L20.4526 21.2166L20.77 23.0632C20.8176 23.3417 20.7065 23.6149 20.478 23.7791L20.4771 23.78C20.2509 23.9458 19.9561 23.9664 19.7065 23.8337H19.7056L18.0503 22.9636L17.9995 22.9363L17.9487 22.9636L16.2896 23.8347C16.1818 23.8916 16.065 23.9206 15.9507 23.9207C15.8 23.9207 15.6512 23.8733 15.522 23.78C15.2942 23.6147 15.1824 23.3416 15.23 23.0632L15.5464 21.2166L15.5562 21.1599L15.5142 21.1199L14.1733 19.8132L14.103 19.7361C13.9558 19.5465 13.9118 19.2972 13.9878 19.0623C14.0759 18.7949 14.3032 18.6048 14.5815 18.5652L16.4321 18.2957L16.4888 18.2878L16.5142 18.2351L17.3433 16.5544C17.4695 16.3029 17.7211 16.1482 17.9995 16.1482Z",
					stroke: "white",
					strokeOpacity: .5,
					strokeWidth: .22
				})]
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_f_10846_87583",
			x: -6.06299,
			y: -11.8455,
			width: 48.2808,
			height: 47.7109,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 10,
					result: "effect1_foregroundBlur_10846_87583"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "bgblur_1_10846_87583_clip_path",
			transform: "translate(17.3765 13.8787)",
			children: /* @__PURE__ */ _jsx("path", { d: "M28.5232 22.0397C27.5892 22.0397 26.8293 21.2867 26.8293 20.3613C26.8293 19.4347 27.5892 18.6817 28.5232 18.6817C28.7496 18.6817 28.9669 18.5926 29.1262 18.4348C29.2866 18.2759 29.3764 18.0606 29.3764 17.8362L29.3753 14.7904C29.3753 12.2158 27.2604 10.1213 24.662 10.1213H11.3379C8.73956 10.1213 6.62467 12.2158 6.62467 14.7904L6.62354 17.9343C6.62354 18.1586 6.71341 18.3739 6.87382 18.5329C7.03309 18.6907 7.25038 18.7797 7.47677 18.7797C8.44263 18.7797 9.17072 19.4595 9.17072 20.3613C9.17072 21.2867 8.41078 22.0397 7.47677 22.0397C7.00578 22.0397 6.62354 22.4185 6.62354 22.8852V25.9288C6.62354 28.5034 8.73728 30.5989 11.3368 30.5989H24.6632C27.2627 30.5989 29.3764 28.5034 29.3764 25.9288V22.8852C29.3764 22.4185 28.9942 22.0397 28.5232 22.0397Z" })
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter2_d_10846_87583",
			x: -1.15869,
			y: 1.03784,
			width: 38.3169,
			height: 37.9932,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 5,
					dy: 5
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 1 0 0 0 0 0.762015 0 0 0 0 0.150053 0 0 0 1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_10846_87583"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_10846_87583",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "bgblur_2_10846_87583_clip_path",
			transform: "translate(1.15869 -1.03784)",
			children: /* @__PURE__ */ _jsx("path", { d: "M21.9028 19.8922L20.5615 21.1982L20.8789 23.0446C20.9335 23.3643 20.8049 23.6794 20.5422 23.8683C20.2816 24.0594 19.9415 24.0833 19.6548 23.9308L17.9995 23.0605L16.3408 23.932C16.218 23.9968 16.0837 24.0309 15.9506 24.0309C15.7766 24.0309 15.6048 23.9763 15.4569 23.8694C15.1952 23.6794 15.0667 23.3643 15.1213 23.0446L15.4375 21.1982L14.0963 19.8922C13.8642 19.6669 13.7834 19.3359 13.8835 19.0276C13.9848 18.7204 14.2464 18.502 14.5661 18.4565L16.4159 18.1869L17.2453 16.5066C17.3897 16.2176 17.6787 16.0378 17.9995 16.0378H18.0018C18.3237 16.039 18.6127 16.2187 18.7549 16.5077L19.5843 18.1869L21.4375 18.4576C21.7537 18.502 22.0154 18.7204 22.1155 19.0276C22.2168 19.3359 22.136 19.6669 21.9028 19.8922Z" })
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_10846_87583",
			x1: 18,
			y1: 10.1213,
			x2: 18,
			y2: 30.5989,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFD977" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FCBD4C"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_10846_87583",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 36,
				height: 36,
				fill: "white"
			})
		})
	] })]
});
export default SvgTypesAttraction;
